import WarningAmber from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { GridPagination, GridSlotsComponentsProps } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";

export default function CustomFooter(props: NonNullable<GridSlotsComponentsProps["footer"]>) {
  const { t } = useTranslation();
  const { deviceCountLimit } = useDataGridSettings();

  return (
    <Box sx={{ p: 1, display: "flex" }}>
      {props.devicecount && props.devicecount >= (deviceCountLimit ?? 1000) && (
        <Box sx={{ width: "50%", display: "flex", flexDirection: "row", alignItems: "center" }}>
          <WarningAmber fontSize="small" />
          <Typography fontSize="small" sx={{ ml: "10px" }}>
            {t("faultOverview.tooManyDevices")}
          </Typography>
        </Box>
      )}
      <Box sx={{ flexGrow: 1 }} />
      <GridPagination {...props} labelRowsPerPage={t("faultOverview.devicesPerPage")} />
    </Box>
  );
}
